import { render, staticRenderFns } from "./FieldSchemaproperties.vue?vue&type=template&id=4614a0cc&scoped=true&"
import script from "./FieldSchemaproperties.vue?vue&type=script&lang=js&"
export * from "./FieldSchemaproperties.vue?vue&type=script&lang=js&"
import style0 from "./FieldSchemaproperties.vue?vue&type=style&index=0&id=4614a0cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614a0cc",
  null
  
)

export default component.exports